import GenericCalculator from "../components/GenericCalculator";
import { Ruler, Box } from "lucide-react";
import { BP_THEME, COLOUR_MAP, BlueprintDefs, BlueprintFrame, DimH, DimV, BlueprintFooter } from "../components/blueprint";

function InfillPreview({ length = 500, width = 500, thickness = 50, colour = "Natural Black" }) {
  const CW = 560, CH = 320;
  const PAD_L = 70, PAD_R = 60, PAD_T = 60, PAD_B = 80;
  const L = Math.max(Number(length) || 0, 50), W = Math.max(Number(width) || 0, 50);
  const innerW = CW - PAD_L - PAD_R, innerH = CH - PAD_T - PAD_B;
  const scale = Math.min(innerW / L, innerH / W);
  const sl = L * scale, sw = W * scale;
  const sx = PAD_L + (innerW - sl) / 2, sy = PAD_T + (innerH - sw) / 2;
  const fill = COLOUR_MAP[colour] || "#1f2330";
  const ID = "if";
  // Iso-skew for 3D feel
  const dz = Math.min((Number(thickness) || 50) * scale * 0.3, 22);
  return (
    <svg viewBox={`0 0 ${CW} ${CH}`} className="w-full h-auto" style={{ maxHeight: 320, background: BP_THEME.bg, borderRadius: 6 }} data-testid="infill-preview">
      <BlueprintDefs id={ID} fill={fill} />
      <BlueprintFrame id={ID} w={CW} h={CH} title="ISO VIEW · RUBBER INFILL" />
      {/* Top face (iso) */}
      <polygon points={`${sx},${sy} ${sx + sl},${sy} ${sx + sl + dz},${sy - dz} ${sx + dz},${sy - dz}`} fill={`url(#fill-${ID})`} stroke={BP_THEME.accent} strokeWidth="1" opacity="0.92" />
      {/* Right face */}
      <polygon points={`${sx + sl},${sy} ${sx + sl + dz},${sy - dz} ${sx + sl + dz},${sy + sw - dz} ${sx + sl},${sy + sw}`} fill={fill} opacity="0.6" stroke={BP_THEME.accent} strokeWidth="1" />
      {/* Front face */}
      <rect x={sx} y={sy} width={sl} height={sw} fill={`url(#fill-${ID})`} stroke={BP_THEME.accent} strokeWidth="1.5" />
      {/* Dimensions */}
      <DimH id={ID} x1={sx} x2={sx + sl} y={sy + sw + 28} label={`L = ${Math.round(L)} mm`} />
      <DimV id={ID} x={sx - 22} y1={sy} y2={sy + sw} label={`W = ${Math.round(W)} mm`} />
      <text x={sx + sl + dz + 10} y={sy - dz / 2 + 4} fontSize="10" fill={BP_THEME.accent} fontFamily={BP_THEME.fontMono} fontWeight="700">⌀ H = {Math.round(thickness)}mm</text>
      <BlueprintFooter w={CW} y={CH - 12} left={`MATERIAL · RUBBER INFILL · ${colour.toUpperCase()}`} />
    </svg>
  );
}

const FIELD_GROUPS = [
  {
    title: "Dimensions (mm)", icon: Ruler,
    fields: [
      { key: "length", label: "Length", type: "number" },
      { key: "width", label: "Width", type: "number" },
      { key: "thickness", label: "Thickness", type: "number" },
      { key: "cutouts", label: "Cut-outs", type: "number" },
    ],
  },
  {
    title: "Options", icon: Box,
    fields: [
      { key: "quantity", label: "Quantity", type: "number" },
      { key: "colour", label: "Colour", type: "colour" },
    ],
  },
];

const DEFAULTS = {
  length: "", width: "", thickness: "",
  cutouts: "", quantity: 1, colour: "Natural Black",
};

export default function InfillCalc() {
  return (
    <GenericCalculator
      productType="infill"
      productLabel="Rubber Infill Calculator"
      defaultInputs={DEFAULTS}
      fieldGroups={FIELD_GROUPS}
      PreviewSvg={InfillPreview}
      endpoint="/calculate/infill"
    />
  );
}
